import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { LightAsync as SyntaxHighlighter } from 'react-syntax-highlighter'
import json from 'react-syntax-highlighter/dist/esm/languages/hljs/json'
import { codify } from '../'
import { Section, IconMessage, Heading, Subheading, BlockCodeWrapper } from '../s'
import Paragraph from 'components/typography/paragraph'
import { Block as BlockCode } from 'components/code'
import { InfoCircleFilled as Info } from 'components/feather'

const WebhookAbsenceEvents = () => {
    useEffect(() => {
        SyntaxHighlighter.registerLanguage('json', json)
    }, [])

    return (
        <Section>
            <Heading>
                <FormattedMessage
                    id="integration_webhook_heading_absence_events"
                    defaultMessage="Absence events" />
            </Heading>
            <Paragraph>
                <FormattedMessage
                    id="integration_webhook_absence_how_to_use_1"
                    defaultMessage="All absence event request bodies include an <code>absence</code> array, which contains an object for each affected absence entry. Each entry object will always contain all supported information for the entry."
                    values={{ code: codify }} />
            </Paragraph>

            <Subheading>
                <FormattedMessage
                    id="integration_webhook_subheading_create"
                    defaultMessage="Create" />
            </Subheading>
            <Paragraph>
                <FormattedMessage
                    id="integration_webhook_absence_preamble_create"
                    defaultMessage="Absence entries being registered in your Huma account is sent as a <code>POST</code> request."
                    values={{ code: codify }} />
            </Paragraph>
            <IconMessage className="info">
                <Info size={20} />
                <Paragraph className="compact">
                    <FormattedMessage
                        id="integration_webhook_example"
                        defaultMessage="For example" />
                </Paragraph>
            </IconMessage>
            <BlockCodeWrapper>
                <BlockCode
                    language="json"
                    code={codeAbsenceCreate} />
            </BlockCodeWrapper>

            <Subheading>
                <FormattedMessage
                    id="integration_webhook_subheading_update"
                    defaultMessage="Update" />
            </Subheading>
            <Paragraph>
                <FormattedMessage
                    id="integration_webhook_absence_preamble_update"
                    defaultMessage="Any update, whether it's a reviewer changing the status, edit by requesting employee, or changes made by a manager on behalf of an employee, is sent as a <code>PATCH</code> request."
                    values={{ code: codify }} />
            </Paragraph>
            <IconMessage className="info">
                <Info size={20} />
                <Paragraph className="compact">
                    <FormattedMessage
                        id="integration_webhook_example"
                        defaultMessage="For example" />
                </Paragraph>
            </IconMessage>
            <BlockCodeWrapper>
                <BlockCode
                    language="json"
                    code={codeAbsenceUpdate} />
            </BlockCodeWrapper>

            <Subheading>
                <FormattedMessage
                    id="integration_webhook_subheading_delete"
                    defaultMessage="Delete" />
            </Subheading>
            <Paragraph>
                <FormattedMessage
                    id="integration_webhook_absence_preamble_delete"
                    defaultMessage="Absence entries being deleted in your Huma account are sent as a <code>DELETE</code> requests. The <code>absence</code> objects only contain identifiers."
                    values={{ code: codify }} />
            </Paragraph>
            <IconMessage className="info">
                <Info size={20} />
                <Paragraph className="compact">
                    <FormattedMessage
                        id="integration_webhook_example"
                        defaultMessage="For example" />
                </Paragraph>
            </IconMessage>
            <BlockCodeWrapper>
                <BlockCode
                    language="json"
                    code={codeAbsenceDelete} />
            </BlockCodeWrapper>
        </Section>
    )
}

const codeAbsenceCreate = `{
    "topic": "absence-create",
    "absence": [
        {
            "id": "45be6bce-88f5-4f67-a6de-cbd84df21e1e",
            "status": "pending",
            "type": {
                "name": "vacation"
            },
            "user": {
                "id": "c2c8d497-352a-4c21-bf7c-aefbaec37717",
                "email": "patrick.remen@godmat.no"
            },
            "startDate": "2022-10-24",
            "endDate": "2022-10-28",
            "workRelated": false,
            "note": null,
            "comment": null,
            "reviewedAt": null,
            "reviewedBy": null,
            "registeredAt": "2022-10-04T11:57:13.819Z",
            "registeredBy": {
                "id": "c2c8d497-352a-4c21-bf7c-aefbaec37717",
                "email": "patrick.remen@godmat.no"
            }
        }
    ]
}`

const codeAbsenceUpdate = `{
    "topic": "absence-update",
    "absence": [
        {
            "id": "e9b5a57f-2f36-462e-aed2-19c6aa990fce",
            "status": "approved",
            "type": {
                "name": "vacation"
            },
            "user": {
                "id": "c2c8d497-352a-4c21-bf7c-aefbaec37717",
                "email": "patrick.remen@godmat.no"
            },
            "startDate": "2022-10-10",
            "endDate": "2022-10-14",
            "workRelated": false,
            "note": null,
            "comment": null,
            "reviewedAt": "2022-10-05T11:57:13.819Z",
            "reviewedBy": {
                "id": "d96434d7-9506-4d5f-a969-7d1eea8bc3d6",
                "email": "jesper.blom@godmat.no",
            },
            "registeredAt": "2022-10-04T11:51:08.962Z",
            "registeredBy": {
                "id": "c2c8d497-352a-4c21-bf7c-aefbaec37717",
                "email": "patrick.remen@godmat.no"
            }
        }
    ]
}`

const codeAbsenceDelete = `{
    "topic": "absence-delete",
    "absence": [
        {
            "id": "e9b5a57f-2f36-462e-aed2-19c6aa990fce"
        }
    ]
}`

export default WebhookAbsenceEvents